import styled from '@emotion/styled'

export const PageFooter = styled('div')(({ customCss }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  ...customCss,
}))
